export default "https://cdn-static.gokick.com/assets/7e8bc23aa9277111cd73fa77d581d1f801b67d5a/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";